import { c as _c } from "react/compiler-runtime";
import useLanguage from "@lib/hooks/useLanguage";
import { formatDate, formatTime } from "@lib/utilities";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import InfoCard from "../InfoCard";
import StatusIcon from "../StatusIcon";
interface CalendarCompleteProps {
  meetingTime?: string;
}
const CalendarComplete = t0 => {
  const $ = _c(41);
  const {
    meetingTime
  } = t0;
  const locale = useLanguage();
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StatusIcon color="success" icon="Check" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("calendarComplete.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h2 className="text-h2 font-semibold">{t2}</h2>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("calendarComplete.date");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== locale || $[8] !== meetingTime) {
    t5 = formatDate(meetingTime, locale);
    $[7] = locale;
    $[8] = meetingTime;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <p>{t4} {t5}</p>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("calendarComplete.time");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== locale || $[16] !== meetingTime) {
    t8 = formatTime(meetingTime, locale);
    $[15] = locale;
    $[16] = meetingTime;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <p>{t7} {t8}</p>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("calendarComplete.nextStepsTitle");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("calendarComplete.nextSteps.email");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("calendarComplete.nextSteps.prepare");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("calendarComplete.nextSteps.appointment");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13) {
    t14 = [t11, t12, t13];
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t10 || $[34] !== t14) {
    t15 = <InfoCard title={t10} list={t14} />;
    $[33] = t10;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t15 || $[37] !== t3 || $[38] !== t6 || $[39] !== t9) {
    t16 = <div className="flex flex-col gap-3s items-center text-center w-[600px] max-w-full">{t1}{t3}{t6}{t9}{t15}</div>;
    $[36] = t15;
    $[37] = t3;
    $[38] = t6;
    $[39] = t9;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
export default CalendarComplete;